/* eslint-disable arrow-body-style */
import React, { useContext } from 'react';
import { Card, SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ThemeColorMode } from 'src/common/enums';
import { Step } from './steps.types';
import { StyledContainer, StyledDescription, StyledIcon, StyledIconGrey, StyledStepContainer, StyledStepNumber, StyledTitle } from './steps.styles';
export const Steps = ({
  data,
  padding = '2.4rem',
  hasVariedColumnWidths = false
}: {
  data: Step[];
  padding?: string;
  hasVariedColumnWidths?: boolean;
}) => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDarkMode = theme === ThemeColorMode.DARK;
  return <Card padding={padding} data-sentry-element="Card" data-sentry-component="Steps" data-sentry-source-file="index.tsx">
      <StyledContainer $isDarkMode={isDarkMode} $hasVariedColumnWidths={hasVariedColumnWidths} data-sentry-element="StyledContainer" data-sentry-source-file="index.tsx">
        {data.map((step, index) => <React.Fragment key={step.stepNumber}>
            <div>
              <StyledStepNumber $isDarkMode={isDarkMode}>{step.stepNumber}</StyledStepNumber>
              <StyledStepContainer>
                <StyledIcon icon={step.icon} $isDarkMode={isDarkMode} />
                <StyledTitle>{step.title}</StyledTitle>
                <StyledDescription $isDarkMode={isDarkMode}>{step.description}</StyledDescription>
              </StyledStepContainer>
            </div>
            {index < data.length - 1 && <StyledIconGrey icon={faArrowRight} />}
          </React.Fragment>)}
      </StyledContainer>
    </Card>;
};